import MfaConstants from 'client/containers/Login/MfaConstants';
import mfaTypes, {
  Duo, Push, Totp, WebAuthn,
} from 'client/containers/user/MfaComponents/mfaUtils/mfaTypes';

// eslint-disable-next-line max-len
export default (mfa: {factors: any[]} = { factors: [] }, options = {}): (Duo | Push | Totp | WebAuthn)[] => {
  const sortOrder: {[index: string]: number} = {
    push: 0,
    totp: 1,
    webauthn: 2,
    duo: 3,
  };

  return mfa.factors
    .map((factor) => mfaTypes(
      {
        factor,
      },
      options,
    ))
    .filter((f) => f.status === MfaConstants.mfaStatus.available)
    .sort((a, b) => sortOrder[a.name] - sortOrder[b.name]);
};
